import { memo, useMemo } from 'react';

import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import Flag from '@atlaskit/flag';
import StatusInformationIcon from '@atlaskit/icon/core/status-information';
import { token } from '@atlaskit/tokens';

import { toggleSettingsDialog } from 'src/redux/diff-settings';
import { ComponentFlagProps } from 'src/redux/flags/types';

import { AppearanceTypes } from '../simple/simple-flag';

import { messages } from './file-mode-onboarding.i18n';

export const FileModeOnboardingFlag = memo((props: ComponentFlagProps) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const { id, handleDismissed } = props;
  const actions = useMemo(() => {
    const actionItems = [
      {
        content: intl.formatMessage(messages.gotItAction),
        onClick: () => {
          handleDismissed(id);
        },
      },
    ];
    actionItems.push({
      content: intl.formatMessage(messages.viewPrefsAction),
      onClick: () => {
        dispatch(toggleSettingsDialog(true));
        handleDismissed(id);
      },
    });
    return actionItems;
  }, [dispatch, intl, handleDismissed, id]);

  return (
    <Flag
      actions={actions}
      appearance={AppearanceTypes.normal}
      description={intl.formatMessage(
        messages.fileModeOnboardingFlagDescription
      )}
      icon={
        <StatusInformationIcon
          spacing="spacious"
          label=""
          color={token('color.icon.discovery')}
        />
      }
      title={intl.formatMessage(messages.fileModeOnboardingFlagTitle)}
      {...props}
    />
  );
});
